import React, { Component } from "react";

import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import Header from "../../../components/Library/Header";
import UpcomingEvents from "../UpcomingEvents";
import PassedEvents from "../PassedEvents";

import styles from "./Events.css";

class Events extends Component {
  render() {
    return (
      <>
        <Header className={styles.events} text="Events" />
        <StandardLayout
          mainAriaLabel="Events"
          main={
            <>
              <UpcomingEvents />
              <PassedEvents story={this.props.story} />
            </>
          }
        />
      </>
    );
  }
}

export default Events;
